import {createReducer} from '../utils';
import {default as types} from '../constants';

const initialState = {
	avaibleProducts: [],
	model: {
		id: null,
		delivery_date: '',
		delivery_hour: '',
		comment: '',
		comment_client: '',
		products: [{
			product_id: null,
			width: '',
			length: '',
			quantity: 1,
			norm: 0,
			m2: 0,
			weight: 0,
			price: 0,
		}],
		discount_code: '',
		exist_discount_code: false,
		is_active_code: false
	}
};

export default createReducer(initialState, {
	[types.CUSTOMER_ORDER_RECEIVE_PRODUCTS]: (state, payload) => {
		return Object.assign({}, state, {
			'avaibleProducts': payload.products,
			'exist_discount_code': payload.discount_code,
			'lamination' : payload.lamination
		});
	},
	[types.CUSTOMER_ORDER_FORM_CREATE]: (state, payload) => {
		return Object.assign({}, state, {
			'model': {
				'id': null,
				'delivery_date': '',
				'delivery_hour': '',
				'comment': '',
				'comment_client': '',
				'products': [{
					product_id: null,
					width: '',
					length: '',
					quantity: 1,
					norm: 0,
					m2: 0
				}],
				'discount_code': '',
				'exist_discount_code': false,
				'is_active_code': false
			}
		});
	},
	[types.CUSTOMER_ORDER_RECEIVE_ORDER]: (state, payload) => {
		return Object.assign({}, state, {
			'model': {
				'id': payload.model.id,
				'delivery_date': payload.model.delivery_date,
				'delivery_hour': payload.model.delivery_hour,
				'discount_code': payload.model.discount_code,
				'comment': payload.model.comment,
				'comment_client': payload.model.comment_client,
				'products': payload.products
			}
		});
	},
	[types.CUSTOMER_ORDER_RECEIVE_ACTIVE_CODE]: (state, payload) => {
		return Object.assign({}, state, {
			'model': {
				'is_active_code': payload.active
			}
		});
	}
});



/** WEBPACK FOOTER **
 ** ./js/reducers/order.js
 **/